import { forwardRef, useEffect } from "react";
import {
  Button,
  TextField,
  Dialog,
  DialogContent,
  Grid,
  Typography,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import { useDispatch, useSelector } from "react-redux";
import {
  setDialog,
  resetForm,
  Provinces,
} from "../../../../../app/slices/provincesSlice";
import { Controller, useForm } from "react-hook-form";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CityForm = (props) => {
  const _SearchBody = useSelector((state) => state.provinces.searchBody);
  const _City = useSelector((state) => state.provinces.cities);
  const _SelectedProvince = useSelector((state) => state.provinces.selectedProvince);

  const isAdd = _City.form.id ? false : true;
  const { control, reset, handleSubmit } = useForm({
    defaultValues: _City.form,
  });

  const onSubmit = (data) => {
    if (isAdd) {
      dispatch(Provinces.create({
        province_id: _SelectedProvince.id ?? props.provinceId,
        name: data.name,
      }, _SearchBody));
    } else {
      dispatch(Provinces.update(data.id, {
        province_id: _SelectedProvince.id,
        name: data.name,
      }, _SearchBody));
    }
  };
  const dispatch = useDispatch();
  useEffect(() => {
    reset({ ..._City.form });
  }, [reset,_City.form]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
  }, [dispatch]);


  const handleDialog = () => {
    dispatch(setDialog());
  };

  return (
    <Dialog
      open={_City.dialog}
      TransitionComponent={Transition}
      keepMounted
      fullWidth={true}
      onClose={() => {
        handleDialog();
      }}
      aria-describedby="alert-dialog-slide-description"
      dir="rtl"
    >
      <DialogContent>
        <Typography
          mb={3}
          variant="h4"
          color={"purple"}
          gutterBottom
          component="div"
        >
          {isAdd ? "أضافة " : "تعديل "}
        </Typography>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Controller
                name="name"
                control={control}
                render={({ field }) => (
                  <TextField
                    required
                    size="small"
                    label="الاسم"
                    fullWidth
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Button type="submit" variant="contained" color="primary">
                حفظ
              </Button>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default CityForm;
